import Vue from "vue";
import Router from "vue-router";

// 基础页面
import Base from "@/components/base";

import Login from "@/components/auth/login";
import Register from "@/components/auth/register";
import Reset from "@/components/auth/reset_password";
import RealReset from "@/components/auth/real_reset";

import Index from "@/components/index";
import Profile from "@/components/user/profile";
import Users from "@/components/user/users";
import Roles from "@/components/user/roles";
import Mails from "@/components/configmaps/mails";
import Ldaps from "@/components/configmaps/ldaps";

import Zones from "@/components/dns/zones";
import Records from "@/components/dns/records"

import Clusters from '@/components/clusters/k8s';
import KubeConfig from '@/components/clusters/kubeconfig'

import ClusterManager from '@/components/kubernetes/cluster_manager'

import Androids from '@/components/kubernetes/androids'
import AndroidProfile from '@/components/kubernetes/profile'
import Terminal from '@/components/kubernetes/terminal'
import Log from '@/components/kubernetes/log'

// // 配置
import config from "@/components/common/config";

Vue.use(Router);

var router = new Router({
    routes: [{
            path: "/login",
            name: "login",
            component: Login,
        },
        {
            path: "/register",
            name: "register",
            component: Register,
        },
        {
            path: "/reset",
            name: "reset",
            component: Reset,
        },
        {
            path: "/real_reset/:token",
            name: "real_reset",
            component: RealReset,
        },
        {
            path: "/",
            name: "base",
            component: Base,
            redirect: "/index",
            children: [{
                    path: "index",
                    name: "index",
                    component: Index,
                    meta: {
                        needLogin: true,
                    },
                },
                {
                    path: "profile",
                    name: "profile",
                    component: Profile,
                    meta: {
                        needLogin: true,
                    },
                },
                {
                    path: "users",
                    name: "users",
                    component: Users,
                    meta: {
                        needLogin: true,
                    },
                },
                {
                    path: "roles",
                    name: "roles",
                    component: Roles,
                    meta: {
                        needLogin: true,
                    },
                },
                {
                    path: "mails",
                    name: "mails",
                    component: Mails,
                    meta: {
                        needLogin: true,
                    },
                },
                {
                    path: "ldaps",
                    name: "ldaps",
                    component: Ldaps,
                    meta: {
                        needLogin: true,
                    },
                },
                {
                    path: "zones",
                    name: "zones",
                    component: Zones,
                    meta: {
                        needLogin: true,
                    },
                },
                {
                    path: "records",
                    name: "records",
                    component: Records,
                    meta: {
                        needLogin: true,
                    },
                },
                {
                    path: 'clusters',
                    name: 'clusters',
                    component: Clusters,
                    meta: {
                        needLogin: true
                    }
                },
                {
                    path: 'kubeconfig/:filename',
                    name: 'kubeconfig',
                    component: KubeConfig,
                    meta: {
                        needLogin: true
                    }
                },
                {
                    path: 'cluster/:id',
                    name: 'cluster_manager',
                    component: ClusterManager,
                    meta: {
                        needLogin: true
                    }
                },
                {
                    path: 'androids',
                    name: 'androids',
                    component: Androids,
                    meta: {
                        needLogin: true
                    }
                },
                {
                    path: 'androidprofile/:cluster/:namespace/:name',
                    name: 'androidprofile',
                    component: AndroidProfile,
                    meta: {
                        needLogin: true
                    }
                },
                {
                    path: 'log/:cluster/:namespace/:name',
                    name: 'log',
                    component: Log,
                    meta: {
                        needLogin: true
                    }
                },
                {
                    path: 'terminal/:cluster/:namespace/:name',
                    name: 'terminal',
                    component: Terminal,
                    meta: {
                        needLogin: true
                    }
                }
            ],
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.meta.needLogin) {
        if (config.isLogin()) {
            next();
        } else {
            next("/login");
        }
    } else {
        next();
    }
});

export default router;